// extracted by mini-css-extract-plugin
export var videoColorPlayButton = "videoColorPlayButton-module--videoColorPlayButton--00809";